import { SimpleUser } from "@/api/types/user"
import { BaseAuthState } from "toptaal-shared"
import { create } from "zustand"
import { persist } from "zustand/middleware"

interface AuthState extends BaseAuthState {
  user: SimpleUser | null
  setUser: (user: SimpleUser) => void
  clearUser: () => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      setToken: (token) => set({ token }),
      refreshToken: null,
      setRefreshToken: (token) => set({ refreshToken: token }),
      getToken: () => get().token,
      getRefreshToken: () => get().refreshToken,
      user: null,
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: null }),
      logout: () => {
        set({ token: null, refreshToken: null, user: null })
      },
    }),
    {
      name: "auth-storage",
    },
  ),
)
